import { journeyAction, } from './base';

import { JourneyActionStartForm as JourneyActionStartFormBase, } from 'atlas-shared';

export const JourneyActionStartForm = journeyAction({
  ...JourneyActionStartFormBase,
  icon: 'Form',
});
